module.exports = __webpack_public_path__ + "img/error-404.dd380f40.svg";